module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-lines-1-3fa86257141d11f4895f1eb810c8ebd9.svg";